<template>
  <v-card
    v-if="value"             
    :style="`position: absolute;top: ${localTop}px;left: ${localLeft}px;width: ${localWidth}px;z-index=2147483647;border: 1px solid red `"   
  >
      <v-card-title
        class="pa-0 ma-0 error"
        style="cursor: move"
        @mousedown="startDragging"
      >
        Scheduling Errors
      </v-card-title>

      <v-card-text
        class="pa-0 ma-0"
      >
        <checkbox-list
          class="pl-3"        
          v-if="facilityErrors && facilityErrors.length"
          :items="facilityErrors"
          v-model="selectedFacilityErrors"
          label="Missing Facilities"
          width="100%"
          height="75px"
          :chips="false"
          :outlined="true"
        />

        <v-btn
          v-if="facilityErrors && facilityErrors.length"
          text
          @click="fixFacilities()"
          class="fs-10 text-none text-decoration-underline pl-3"
          :loading="fixingFacilities"
          :disabled="(!selectedFacilityErrors || !selectedFacilityErrors.length) ? true : false"
        >
          Fix Facilities
        </v-btn>

      </v-card-text>
      <v-card-text
        class="pa-0 ma-0"
      >        
        <checkbox-list
          class="pl-3"
          v-if="providerErrors && providerErrors.length"
          :items="providerErrors"
          v-model="selectedProviderErrors"
          label="Providers"
          width="100%"
          height="75px"
          :chips="false"
          :outlined="true"
        />

        <v-btn
          text
          v-if="providerErrors && providerErrors.length"
          @click="fixProviders()"
          class="fs-10 text-none text-decoration-underline pl-3"
          :loading="fixingProviders"
          :disabled="(!selectedProviderErrors || !selectedProviderErrors.length) ? true : false"
        >
          Fix Providers
        </v-btn>


      </v-card-text>
     
  </v-card>


</template>

<script>
import {mapActions, mapGetters} from "vuex";
import checkboxList from '@/components/checkbox-list'

  export default {
    props: {
      value: {
        default: false,
        type: Boolean
      },      
      width: {
        default: 500,
        type: Number        
      },
      errors: {
          type: Array,
          default: () => []
      },  
      top: {
        default: 0,
        type: Number
      },  
      left: {
        default: 760,
        type: Number
      }          
                         
    },
    components: {
      'checkbox-list': checkboxList,
    },    
    data: () => ({
      localWidth: null,
      localTop: null,
      localHeight: null,
      localLeft: null,
      dragging: false,
      dragOffset: {x: 0, y: 0},
      selectedFacilityErrors: null,
      fixingFacilities: false,
      selectedProviderErrors: null,
      fixingProviders: false,
      parentHeight: null,
      parentWidth: null
    }),
    mounted() {
      this.localWidth = this.width
      this.localTop = this.top
      this.localHeight = this.height
      this.localLeft = this.left
      let el = this.$el
      let i = 0
      while (el && ++i < 1000) {
        console.log('el.tagName', el.tagName)
        console.log('el.classList',el.classList)

        console.log('el.clientWidth', el.clientWidth)
        console.log('el.clientHeight', el.clientHeight)
        console.log('el.offsetWidth', el.offsetWidth)
        console.log('el.offsetHeight', el.offsetHeight)

        if (el.classList && el.classList.contains('ycmd-draggable-container')) {

          this.parentHeight = el.clientHeight
          this.parentWidth =  el.clientWidth
          break
        }
        el = el.parentElement
      }



    },
    methods: {
      ...mapActions('schedule',['saveShift']),

      fixProviders () {
        console.log('this.providerErrors', this.providerErrors)

        this.fixingProviders = true
        let params = {}
        this.selectedProviderErrors.map(id => {
          console.log('id', id)


          let pieces = id.split('|')
          let user_id = pieces[2]
          let facility_id = pieces[1]

          let key = user_id
          if (!params[key]) {
            params[key] = {}
          }
          params[key][facility_id] = true
        })


        let providers = {}

        for (let userId in params) {
          let facilities = params[userId]
          providers[`provider_${userId}`] = []
          for (let f in facilities) {
            providers[`provider_${userId}`].push(f)
          }
        }

        let params2 = {
          providers,
          callback: this.finishedFixing
        }

        this.$emit('fixProviders', params2)

      },
      finishedFixing(params) {

        if (params.type === 'facilities') {
          this.fixingFacilities = false
        } else if (params.type === 'providers') {
          this.fixingProviders = false
        }
        
      },
      fixFacilities () {

        this.fixingFacilities = true
        let errorMap = {}
        this.facilityErrors.map(fe => {
          errorMap[fe.id] = fe
        })

        let facilities = []
        this.selectedFacilityErrors.map(id => {
          facilities.push(errorMap[id])
        }) 
        let params = {
          facilities,
          callback:this.finishedFixing
        }

        this.$emit('fixFacilities', params)
    
      },
      startDragging(event) {
        console.log('startDragging', event)
        this.dragging = true
        this.dragOffset.x = event.clientX - this.localLeft
        this.dragOffset.y = event.clientY - this.localTop

        document.addEventListener('mousemove', this.drag)
        document.addEventListener('mouseup', this.stopDragging)

      },
      drag(event) {
        console.log('drag', event)    
        console.log('event.clientWidth', event.clientWidth)
        console.log('event.clientHeight', event.clientHeight)
        console.log('event.clientX', event.clientX)
        console.log('event.clientY', event.clientY)

        if (this.dragging) {
          this.localLeft = event.clientX - this.dragOffset.x
          this.localTop = event.clientY - this.dragOffset.y

          if (this.localTop < 0) {
            this.localTop = 0
          }

          if (this.parentHeight) {
            let max = this.parentHeight - 50
            if (this.localTop > max) {
              this.localTop = max
            }
          }


          let minWidth = -1 * (this.localWidth - 50)
          if (this.localLeft < minWidth) {
            this.localLeft = minWidth
          }


          if (this.parentWidth) {
            console.log('this.parentWidth', this.parentWidth)
            let max = this.parentWidth - 50
            console.log('max', max)

            if (this.localLeft > max) {
              this.localLeft = max
            }
          }



          console.log('this.localLeft', this.localLeft)
          console.log('this.localTop', this.localTop)
        }
      },
      stopDragging(event) {
        console.log('stopDragging', event)        
        this.dragging = false

        document.removeEventListener('mousemove', this.drag)
        document.removeEventListener('mouseup', this.stopDragging)

      },

    },
    computed: {
      facilityErrors () {
        let arr = []

        let facilities = {}
        this.errors.map(e => {

          let id = e.params.facility_id

          switch (e.type) {
            case 'pod_missing_facility':
              if (!facilities[id]) {
                facilities[id] = {
                  name: e.message,
                  error: {}
                }
              }
              if (facilities[id]) {
                facilities[id].pod = true
                facilities[id].error[e.id] = e
              }               
              break
            case 'group_missing_facility':
              if (!facilities[id]) {
                facilities[id] = {
                  name: e.message,
                  error: {}
                }
              }
              if (facilities[id]) {
                facilities[id].group = true
                facilities[id].error[e.id] = e
              }               
              break
            case 'provider_missing_facility':            
              break
          }

        })

        for (let facId in facilities) {
          let err = facilities[facId]

          let message = ''
          if (err.pod && err.group) {
            message += '(Pod, Group)'
          } else if (err.pod) {
            message += '(Pod)'
          } else if (err.group) {
            message += '(Group)'
          }

          arr.push({
            id: facId,
            name: `${err.name} ${message}`,
            error: err.error
          })
        
        }

        return arr
      },
      providerErrors () {
        let arr = []
        this.errors.map(e => {

          switch (e.type) {
              case 'provider_missing_facility':

                arr.push({
                  id: e.id,
                  name: `${e.message}`
                })                
          }
        })

        return arr
      }

    },
    watch: {
      errors: {
          handler (val, oldVal) {
            this.localWidth = this.width
            this.localTop = this.top
            this.localHeight = this.height
            this.localLeft = this.left
          },
          deep: true
      },
    }
  }
</script>

<style scoped>
.schedule-errors .v-overlay--active {
  pointer-events: none !important;
}
.schedule-errors .v-dialog {
  pointer-events: auto;
}
</style>

